import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FastField } from 'formik';

const Checkbox = props => (
  <FastField name={props.name}>
    {({ field, form }) => (
      <div className="form-group">
        {!props.hideLabel && (
          <label>{props.label}</label>
        )}
        <div className="checkbox checkbox-theme checkbox-circle" style={{ paddingLeft: '20px' }}>
          <input
            type="checkbox"
            checked={form.values[field.name]}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            {...field}
            name={props.name}
            id={props.id || props.name}
            className={`input-checkbox ${form.touched[field.name] && form.errors[field.name]
            ? 'input-text-error'
            : ''}`}
          />
          {props.children ? (
            <Fragment>{props.children}</Fragment>
          ) : (
            <label style={{ display: 'block' }} htmlFor={props.id || props.name}>{props.checkLabel}</label>
          )}
          {form.touched[field.name] && form.errors[field.name] && (
          <span style={{ display: 'block' }} className="input-text-error-msg">{props.error || form.errors[field.name]}</span>
        )}
        </div>
      </div>
    )}
  </FastField>
);

Checkbox.propTypes = {
  hideLabel: PropTypes.bool,
  checkLabel: PropTypes.string,
};

Checkbox.defaultProps = {
  hideLabel: false,
  checkLabel: '',
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js